// A tiny highlighter for the code the site shows (JSX props, JSON, imports, comments).
import { Fragment, type ReactNode } from 'react';

const RE = /(\/\/[^\n]*)|("(?:[^"\\]|\\.)*")(\s*:)?|\b(import|from|const)\b|([A-Za-z]\w*)(?==)|(-?\d+(?:\.\d+)?)|(<\/?[A-Za-z]+|\/?>|[{}])/g;
export function highlight(src: string): ReactNode {
  const out: ReactNode[] = [];
  let last = 0, m: RegExpExecArray | null, k = 0;
  RE.lastIndex = 0;
  while ((m = RE.exec(src))) {
    out.push(src.slice(last, m.index));
    if (m[1]) out.push(<span key={k++} className="tk-c">{m[1]}</span>);
    else if (m[2]) out.push(m[3] ? <Fragment key={k++}><span className="tk-k">{m[2]}</span>{m[3]}</Fragment> : <span key={k++} className="tk-s">{m[2]}</span>);
    else if (m[4]) out.push(<span key={k++} className="tk-w">{m[4]}</span>);
    else if (m[5]) out.push(<span key={k++} className="tk-k">{m[5]}</span>);
    else if (m[6]) out.push(<span key={k++} className="tk-n">{m[6]}</span>);
    else out.push(<span key={k++} className="tk-p">{m[7]}</span>);
    last = RE.lastIndex;
  }
  out.push(src.slice(last));
  return out;
}
